import { render, staticRenderFns } from "./koraDocument.vue?vue&type=template&id=ceb726b2"
import script from "./koraDocument.vue?vue&type=script&lang=js"
export * from "./koraDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ceb726b2')) {
      api.createRecord('ceb726b2', component.options)
    } else {
      api.reload('ceb726b2', component.options)
    }
    module.hot.accept("./koraDocument.vue?vue&type=template&id=ceb726b2", function () {
      api.rerender('ceb726b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/mdm/mam/kora/koraDocument.vue"
export default component.exports